module.exports = __webpack_public_path__ + "media/images/lp_free-af4ee653144a65224a64f431db656f96.webp";